const routes = {
  MAIN_CONTENT: {
    component: () => import('@/layout/components/MainContent' /* webpackChunkName: "Route.MainContent", webpackPrefetch: 0 */),
  },
  REDIRECT_PAGE: {
    component: () => import('@/layout/components/RedirectPage' /* webpackChunkName: "Route.RedirectPage", webpackPrefetch: 0 */),
  },
}

export default routes
